import React, { useEffect, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeScanType, Html5QrcodeSupportedFormats } from 'html5-qrcode';

const QRScanner = ({ onDecode, onError, stopStream }) => {
  const videoRef = useRef(null);
  const html5QrCodeRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    html5QrCodeRef.current = new Html5Qrcode(video.id,
        {
          formatsToSupport: [ Html5QrcodeSupportedFormats.CODE_128],
          useBarCodeDetectorIfSupported: true,
          fps: 10,
          // qrbox: { width: 800, height: 800 },
          aspectRatio: 1.333334,
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
          showTorchButtonIfSupported: true,
        }
    );

    const config = {
      fps: 25,
      qrbox: { width: 800, height: 800 },
      aspectRatio: 1.333334,
      supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
      showTorchButtonIfSupported: true,
    };

    html5QrCodeRef.current
      .start({ facingMode: 'environment' }, config, (decodedText, result) => {
          onDecode(decodedText);
      }, (message, err) => {
          if (err?.type != 0) {
              onError(err);
          }
      })
      .catch((err) => {
        onError(err);
      });

    return () => {
      if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) {
        html5QrCodeRef.current.stop().catch((err) => {
          console.error('Failed to stop scanner', err);
        });
      }
    };
  }, [onDecode, onError]);

  useEffect(() => {
    if (stopStream && html5QrCodeRef.current && html5QrCodeRef.current.isScanning) {
      html5QrCodeRef.current.stop().catch((err)  => {
        console.error('Failed to stop scanner', err);
      });
    }
  }, [stopStream]);

  return <div id="qr-reader" ref={videoRef} style={{width: '800px', height: '800px'}}/>;
};

export default QRScanner;
